import { checkBdApp } from '../../hooks/bdapp/useBdApp'
import { publish } from '../../hooks/bdapp/useBdAppEventBus'

export const jsonParaCsv = (dados: any) => {
  if (!dados.length) return ''

  const colunas = Object.keys(dados[0])
  const cabeçalho = colunas.join(',')
  const linhas = dados.map((obj: any) =>
    colunas.map((col) => `"${obj[col]}"`).join(',')
  )

  return [cabeçalho, ...linhas].join('\n')
}

export const baixarCsv = (dados: any, nomeArquivo = 'dados.csv') => {
  const { isNative } = checkBdApp()

  if (isNative) {
    publish('download', {
      dataInBase64: btoa(dados),
      fileName: nomeArquivo,
      mimeType: 'text/csv',
    })
    return
  }

  const csv = jsonParaCsv(dados)
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', nomeArquivo)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const baixarPdf = async (urlPdf: string, nomeArquivo = 'arquivo.pdf') => {
  const { isNative } = checkBdApp()

  if (isNative) {
    publish('download-from-url', {
      url: urlPdf,
      fileName: nomeArquivo,
      mimeType: 'application/pdf',
    })
    return
  }

  const link = document.createElement('a')
  link.href = urlPdf
  link.setAttribute('download', nomeArquivo)
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

type Potencial = {
  data: string
  potencialTotal: number
  antecipadoTotal: number
  porcentagemConvertidaTotal: number
}

export function gerarTabelaResumoPotencial(dados: any): Potencial[] {
  if (!dados?.potenciais || !Array.isArray(dados.potenciais)) {
    throw new Error("Formato inválido: campo 'potenciais' não encontrado.")
  }

  return dados.potenciais.map((item: any) => ({
    data: item.data,
    potencialTotal: item.potencialTotal,
    antecipadoTotal: item.antecipadoTotal,
    porcentagemConvertidaTotal: item.porcentagemConvertidaTotal,
  }))
}

export type FaturamentoDia = {
  data: string
  faturamentoSemJuros: number
  faturamentoComJuros: number
  totalFaturamentoDia: number
}

export function calcularFaturamentoPorDia(antecipados: {
  origemWeb: { valorPorDia: any[] }
  origemTEF: { valorPorDia: any[] }
}): FaturamentoDia[] {
  const map = new Map<string, { sem: number; com: number }>()

  const acumular = (registros: any[]) => {
    for (const reg of registros) {
      const data = reg.data
      const custoSem = reg.custoTotalSemJuros ?? 0
      const custoCom = reg.custoTotalComJuros ?? 0

      if (!map.has(data)) {
        map.set(data, { sem: 0, com: 0 })
      }

      const item = map.get(data)!
      item.sem += custoSem
      item.com += custoCom
    }
  }

  acumular(antecipados.origemWeb.valorPorDia)
  acumular(antecipados.origemTEF.valorPorDia)

  return Array.from(map.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([data, { sem, com }]) => ({
      data,
      faturamentoSemJuros: sem,
      faturamentoComJuros: com,
      totalFaturamentoDia: sem + com,
    }))
}
